/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_SaveInputs */

const th_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง`)
};

const en_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

const ja_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を保存`)
};

const zh_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存更改`)
};

const es_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const pt_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações`)
};

const id_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan perubahan`)
};

const fr_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const tl_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-save ang mga pagbabago`)
};

const vi_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu thay đổi`)
};

const ko_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 사항 저장`)
};

const de_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

const ru_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить изменения`)
};

const tr_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklikleri kaydet`)
};

const it_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le modifiche`)
};

const pl_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz zmiany`)
};

const uk_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зберегти зміни`)
};

const hi_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव सहेजें`)
};

const ar_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ التغييرات`)
};

const ms_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan perubahan`)
};

const bn_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিবর্তন সংরক্ষণ করুন`)
};

const zh_tw2_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存變更`)
};

const zh_hk2_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存變更`)
};

const ur_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبدیلیاں محفوظ کریں`)
};

const fa_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذخیرهٔ تغییرات`)
};

const sw_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hifadhi mabadiliko`)
};

const nl_event_save = /** @type {(inputs: Event_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen opslaan`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Event_SaveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_save = /** @type {((inputs?: Event_SaveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_SaveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_save(inputs)
	if (locale === "ja") return ja_event_save(inputs)
	if (locale === "zh") return zh_event_save(inputs)
	if (locale === "es") return es_event_save(inputs)
	if (locale === "pt") return pt_event_save(inputs)
	if (locale === "id") return id_event_save(inputs)
	if (locale === "fr") return fr_event_save(inputs)
	if (locale === "tl") return tl_event_save(inputs)
	if (locale === "vi") return vi_event_save(inputs)
	if (locale === "ko") return ko_event_save(inputs)
	if (locale === "de") return de_event_save(inputs)
	if (locale === "ru") return ru_event_save(inputs)
	if (locale === "tr") return tr_event_save(inputs)
	if (locale === "it") return it_event_save(inputs)
	if (locale === "pl") return pl_event_save(inputs)
	if (locale === "uk") return uk_event_save(inputs)
	if (locale === "hi") return hi_event_save(inputs)
	if (locale === "ar") return ar_event_save(inputs)
	if (locale === "ms") return ms_event_save(inputs)
	if (locale === "bn") return bn_event_save(inputs)
	if (locale === "zh-TW") return zh_tw2_event_save(inputs)
	if (locale === "zh-HK") return zh_hk2_event_save(inputs)
	if (locale === "ur") return ur_event_save(inputs)
	if (locale === "fa") return fa_event_save(inputs)
	if (locale === "sw") return sw_event_save(inputs)
	if (locale === "nl") return nl_event_save(inputs)
	return en_event_save(inputs)
});